const PHASE_PRODUCTION_BUILD = 'phase-production-build';

/**
 * True only while `next build` is generating pages, including a Vercel build.
 * False for dev, `next start`, and request-time serverless rendering.
 */
export function isNextProductionBuild(): boolean {
  return process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD;
}
